export const resetPasswordURLString = (username: string): string => {
  const url = `/pwreset/?username=${encodeURIComponent(username)}`;
  const urlParams = new URLSearchParams(window.location.search);

  const redirect = urlParams.get('redirect');
  return redirect ? `${url}&redirect=${redirect}` : url;
};
